export const comments_5618951 = {"data":{"data":[],"links":{}}}